import { useEffect, useState } from "react";
import type { PlatformClient } from "../../platform/supabase";

function fmt(value?:string|null){
  if(!value)return "-";
  return new Date(value).toLocaleString("ko-KR",{year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit"});
}
function statusLabel(value:string){
  const map:Record<string,string>={REQUESTED:"확약 확인 대기",CONFIRMED:"확약 완료",DECLINED:"진행 불가",CANCELLED:"요청 취소",COMPLETED:"완료",EXPIRED:"링크 만료"};
  return map[value]||value;
}
type ProviderRequest={
  engagementId:string;status:string;schoolName:string;providerName:string;
  programTitle:string;activityTitle:string;activityType:string;
  startsAt:string;endsAt:string;locationName?:string|null;
  requestedCapacity:number;confirmedCapacity?:number|null;
  contactName?:string|null;tokenExpiresAt:string;
  decisionSignerName?:string|null;decisionNote?:string|null;decidedAt?:string|null;
  studentRosterShared:boolean;
};

export function ProviderSessionPublicPage({client,token}:{client:PlatformClient;token:string}){
  const [data,setData]=useState<ProviderRequest|null>(null);
  const [signer,setSigner]=useState("");
  const [capacity,setCapacity]=useState("");
  const [note,setNote]=useState("");
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState("");
  const [message,setMessage]=useState("");
  const [refresh,setRefresh]=useState(0);

  useEffect(()=>{
    let active=true;setError("");
    if(!token){setError("파트너 확인 링크가 올바르지 않습니다.");return;}
    client.rpc("public_provider_session_request",{p_token:token}).then(({data,error})=>{
      if(!active)return;
      if(error){setError(error.message);return;}
      const next=data as ProviderRequest;setData(next);
      setSigner(v=>v||next.contactName||"");
      setCapacity(v=>v||String(next.requestedCapacity||""));
    });
    return()=>{active=false;};
  },[client,token,refresh]);

  async function decide(decision:"CONFIRM"|"DECLINE"){
    if(!signer.trim())return;
    setBusy(true);setError("");setMessage("");
    const {error}=await client.rpc("public_decide_provider_session_request",{
      p_token:token,p_decision:decision,p_signer_name:signer.trim(),
      p_confirmed_capacity:decision==="CONFIRM"?Number(capacity):null,
      p_note:note.trim()||null
    });
    setBusy(false);
    if(error){setError(error.message);return;}
    setMessage(decision==="CONFIRM"?"세션 운영 확약이 기록되었습니다.":"진행 불가 응답이 기록되었습니다.");
    setRefresh(v=>v+1);
  }

  return <main className="erp13-public-page"><section className="erp13-public-card">
    <div className="erp12-public-brand"><span className="brand-mark">RS</span><div><strong>RS CAREER ERP</strong><small>외부 체험처 운영 확인</small></div></div>
    {error?<div className="erp12-public-state error"><strong>링크를 확인할 수 없습니다.</strong><p>{error}</p></div>:!data?<p className="muted">세션 요청을 불러오는 중…</p>:<>
      <header><p className="eyebrow">Provider Session Confirmation</p><h1>{data.activityTitle}</h1><p>{data.schoolName}에서 {data.providerName}에 요청한 외부 진로체험 세션입니다.</p></header>
      {message&&<p className="teacher-success">{message}</p>}
      <div className="erp13-public-summary">
        <div><span>프로그램</span><strong>{data.programTitle}</strong></div>
        <div><span>활동유형</span><strong>{data.activityType}</strong></div>
        <div><span>시작</span><strong>{fmt(data.startsAt)}</strong></div>
        <div><span>종료</span><strong>{fmt(data.endsAt)}</strong></div>
        <div><span>장소</span><strong>{data.locationName||"미정"}</strong></div>
        <div><span>요청정원</span><strong>{data.requestedCapacity}명</strong></div>
        <div><span>현재 상태</span><strong>{statusLabel(data.status)}</strong></div>
        <div><span>링크 만료</span><strong>{fmt(data.tokenExpiresAt)}</strong></div>
      </div>
      <section className="erp13-public-privacy"><strong>학생 명단은 이 링크에 포함되지 않습니다.</strong><p>본 링크는 일정·장소·수용인원 확약 전용입니다. 학생정보 공유가 필요한 경우 학교의 별도 동의·공유 절차를 사용합니다.</p></section>
      {data.status==="REQUESTED"&&<section className="erp13-public-decision">
        <label>확인자 이름<input value={signer} onChange={e=>setSigner(e.target.value)}/></label>
        <label>확정 가능 인원<input type="number" min="1" max={data.requestedCapacity} value={capacity} onChange={e=>setCapacity(e.target.value)}/></label>
        <label>메모 (선택)<textarea rows={3} value={note} onChange={e=>setNote(e.target.value)}/></label>
        <div><button className="primary" disabled={busy||!signer.trim()||Number(capacity)<1} onClick={()=>decide("CONFIRM")}>일정·정원 확약</button><button className="secondary" disabled={busy||!signer.trim()} onClick={()=>decide("DECLINE")}>진행 불가</button></div>
      </section>}
      {data.status!=="REQUESTED"&&<div className={data.status==="CONFIRMED"?"erp12-public-state good":"erp12-public-state"}><strong>{statusLabel(data.status)}</strong><p>{data.decisionSignerName||"-"} · {fmt(data.decidedAt)}{data.confirmedCapacity?" · 확정 "+data.confirmedCapacity+"명":""}</p>{data.decisionNote&&<p>{data.decisionNote}</p>}</div>}
      <footer><span>학생명단 공유: {data.studentRosterShared?"예":"아니오"}</span><span>기관용 일정 확약 화면</span></footer>
    </>}
  </section></main>;
}
